import { render, staticRenderFns } from "./AccountGroups.vue?vue&type=template&id=615eef74&"
import script from "./AccountGroups.vue?vue&type=script&lang=js&"
export * from "./AccountGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports